import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface ClienteItem {
    id: number
    nome: string
    email: string | null
    telefone: string | null
    facebookId: string | null
    totalSelos: number | null
    receberSpam: boolean
    dataCadastro: number | null
    dataNascimento: number | null
    dataRetorno: number | null
    dataUltimaNotificacao: number | null
}

export interface ResultadoClientes {
    clientes: ClienteItem[]
    total: number
}

export interface FiltroClientes {
    nome: string
    email: string
    telefone: string
    cidade: string
    bairro: string
    spam: string
    diasAusenciaInicio: string
    diasAusenciaFinal: string
    dataInicioCadastro: string
    dataFimCadastro: string
    dataInicioNascimento: string
    dataFimNascimento: string
    idadeInicio: string
    idadeFinal: string
    sexo: string
    apenasNaoNotificadsoDias: string
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaRaw<T> = T & { codErro?: number; mensagem?: string }

function tratamentoResponse<T>(response: { data: RespostaRaw<T> }, chamada: string): T | ErroApi {
    const { data } = response
    if (data.codErro !== undefined && data.codErro > 0) {
        return { retornoErro: data.codErro, mensagem: data.mensagem ?? "" }
    }
    if (typeof data === "string" && data !== "") {
        return {
            retornoErro: 1,
            mensagem: `${chamada} - Erro inesperado, entre em contato com os responsáveis.`,
        }
    }
    return data
}

function erroParaRespostaRaw(error: unknown): RespostaRaw<never> {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as { codErro: number }).codErro > 0
    ) {
        const d = data as { codErro: number; mensagem?: string }
        return { codErro: d.codErro, mensagem: d.mensagem } as RespostaRaw<never>
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" } as RespostaRaw<never>
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" } as RespostaRaw<never>
}

function filtroParaPayload(filtro: FiltroClientes, pagina: number, tamanhoPagina: number) {
    const payload: Record<string, unknown> = { pagina, tamanhoPagina }
    if (filtro.nome) payload.nome = filtro.nome
    if (filtro.email) payload.email = filtro.email
    if (filtro.telefone) payload.telefone = filtro.telefone
    if (filtro.cidade) payload.cidade = filtro.cidade
    if (filtro.bairro) payload.bairro = filtro.bairro
    if (filtro.spam !== "") payload.spam = Number(filtro.spam)
    if (filtro.diasAusenciaInicio) payload.diasAusenciaInicio = Number(filtro.diasAusenciaInicio)
    if (filtro.diasAusenciaFinal) payload.diasAusenciaFinal = Number(filtro.diasAusenciaFinal)
    if (filtro.dataInicioCadastro) payload.dataInicioCadastro = filtro.dataInicioCadastro
    if (filtro.dataFimCadastro) payload.dataFimCadastro = filtro.dataFimCadastro
    if (filtro.dataInicioNascimento) payload.dataInicioNascimento = filtro.dataInicioNascimento
    if (filtro.dataFimNascimento) payload.dataFimNascimento = filtro.dataFimNascimento
    if (filtro.idadeInicio) payload.idadeInicio = Number(filtro.idadeInicio)
    if (filtro.idadeFinal) payload.idadeFinal = Number(filtro.idadeFinal)
    if (filtro.sexo === "masculino") payload.sexo = 1
    else if (filtro.sexo === "feminino") payload.sexo = 2
    if (filtro.apenasNaoNotificadsoDias)
        payload.apenasNaoNotificadsoDias = Number(filtro.apenasNaoNotificadsoDias)
    return payload
}

export interface ResultadoImportacao {
    importados: number
    erros: string[]
}

export const importarClientesPainel = async function (
    authorization: string,
    conteudo: string
): Promise<ResultadoImportacao | ErroApi> {
    try {
        const response = await api
            .post<RespostaRaw<ResultadoImportacao>>(
                "clientefiel/ImportarClientesPainel",
                { conteudo },
                {
                    headers: { "Content-Type": "application/json", Authorization: authorization },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<ResultadoImportacao>(response, "ImportarClientesPainel")
    } catch (error) {
        RegistrarLogErro(error, "ImportarClientesPainel", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const obterClientesPainel = async function (
    authorization: string,
    filtro: FiltroClientes,
    pagina: number,
    tamanhoPagina: number
): Promise<ResultadoClientes | ErroApi> {
    try {
        const payload = filtroParaPayload(filtro, pagina, tamanhoPagina)
        const response = await api
            .post<RespostaRaw<ResultadoClientes>>("clientefiel/ObterClientesPainel", payload, {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<ResultadoClientes>(response, "ObterClientesPainel")
    } catch (error) {
        RegistrarLogErro(error, "ObterClientesPainel", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
